import { render, staticRenderFns } from "./SysContentMangeIndex.vue?vue&type=template&id=4d7686a7&scoped=true"
import script from "./SysContentMangeIndex.vue?vue&type=script&lang=js"
export * from "./SysContentMangeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7686a7",
  null
  
)

export default component.exports